$( document ).ready(function() {

    $( document ).on('click', '.edit-user', function() {

        var user_url = $(this).attr('id');
        var id = user_url.replace('/users/edit-user/', '').replace('/', '');

        console.log('this is the id='+id + ', this is the url='+user_url);
        $('.modal').html('&nbsp;').load(user_url);

    });
});
